export default "__VITE_ASSET__DAmlG_AR__"